import React from 'react';
import RoleSuccessPage from '../RoleManagement/RoleSuccessPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './ShopSuccessPage.module.css';
import qrCode from '../../assets/images/qr-admin.png';

const ShopSuccessPage: React.FC = () => (
  <RoleSuccessPage config={ROLE_CONFIGS.shop} styles={styles} staticQrImage={qrCode} />
);

export default ShopSuccessPage;
